<template>
    <section>
        <!--工具条-->
        <el-col v-if="buttonList != null && buttonList.length > 0" :span="24" style="padding-bottom: 0px;">

            <el-form :inline="true" :model="search">
                <el-form-item label="产品名称">
                    <el-input v-model="search.title" placeholder="请输入产品名称"  @keyup.enter.native="query" clearable ></el-input>
                  
                </el-form-item>        
                        <el-form-item label="产品主分类">
                            <el-cascader style="width: 100%" clearable v-model="search.TypeId" :options="TypeList" :props="{
                                expandTrigger: 'hover',
                                children: 'Children',
                                label: 'Title',
                                value: 'Id', checkStrictly: true
                            }" @change="edithandleChange">
                            </el-cascader>
                        </el-form-item>
                <el-form-item v-for="item in buttonList" v-bind:key="item.id">
                    <!-- 这里触发点击事件 -->
                    <el-button
                        :type="item.Func && (item.Func.toLowerCase().indexOf('handledel') != -1 || item.Func.toLowerCase().indexOf('stop') != -1) ? 'danger' : 'primary'"
                        v-if="!item.IsHide && (item.Func=='Add'|| item.Func== 'query')" @click="callFunc(item)">{{
                        item.name }}</el-button>
                </el-form-item>
            </el-form>
           
            <el-form :inline="true" v-if="tags!=null && tags.length>0">
                <el-form-item label="点击查询搜索历史：" >
                    <el-tag v-for="tag in tags" :key="tag.Id" type="info" style="margin-left: 1%;"
                        @click="tagclick(tag.QueryProductName)">
                        {{ tag.QueryProductName }}
                    </el-tag>
                </el-form-item>

            </el-form>
        </el-col>

        <el-col :span="24">
            <!--列表-->
            <el-table :data="data" v-loading="listLoading" row-key="Id" style="width: 100%" ref="table"
                class="custom-tbl"  :row-class-name="tableRowClassName">
                <el-table-column type="index" width="50" label="序号"> </el-table-column>
                <el-table-column prop="Title" label="产品名称" width="200">
                     <template slot-scope="scope">
                        <el-popover
                              placement="right" width="400" trigger="hover">
                            <el-table :data="scope.row.MatnrInfolist">
                            <el-table-column  property="TivCode" label="货号编码"></el-table-column>
                            <el-table-column property="Matnr" label="物料编码"></el-table-column>
                             <el-table-column property="MSTAEString" label="物料状态"></el-table-column>
                            <el-table-column  property="Matkl" label="物料组"></el-table-column>
                           </el-table>
                            <el-button slot="reference" type="text">{{scope.row.Title}}</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column prop="FirstPng" label="首图" width="150">
                    <template scope="scope">
                        <span v-if="scope.row.FirstPngUrl!=null">
                            <el-popover placement="left" trigger="click" style="width:400px;cursor:pointer;">
                                <img :src="scope.row.FirstPngUrl" width="100%" />
                                <img slot="reference" :src="scope.row.FirstPngUrl" :alt="scope.row.FirstPngUrl"
                                    width="60" height="60" />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="Sort" label="排序" width></el-table-column>
                <el-table-column prop="CreateBy" label="创建用户" width></el-table-column>
                <el-table-column prop="CreateTimeString" label="创建时间" width></el-table-column>
                <el-table-column prop="ModifyTimeString" label="最后修改时间" width></el-table-column>
                <el-table-column prop="Enabled" label="状态" width>
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.Status==0 ? 'success' : 'danger'" disable-transitions>{{
                            scope.row.Status==0 ? "启用" : "停用" }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="FirstPng" label="小程序码" width="100">
                    <template scope="scope">
                        <span v-if="scope.row.QRcodeUrl!=null">
                            <el-popover placement="left" trigger="click" style="width:400px;cursor:pointer;">
                                <img :src="scope.row.QRcodeUrl" width="100%" />
                                <img slot="reference" :src="scope.row.QRcodeUrl" :alt="scope.row.QRcodeUrl" width="60"
                                    height="60" />
                            </el-popover>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="150">
                    <template slot-scope="scope">
                        <el-row>
                            <el-col :span="12">
                                <el-button size="mini" type="primary"
                                    v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('Update') != -1).length > 0"
                                    @click="update(scope.row)">编辑</el-button>
                            </el-col>
                            <el-col :span="12">
                                <el-button type="info" size="mini"
                                    v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('handledel') != -1).length > 0"
                                    @click="handledel(scope.row)">删除</el-button>
                            </el-col>
                        </el-row>
                        <el-row>
                          <el-col :span="24">
                                <el-button type="primary" plain size="mini" style="margin-top: 10px;"
                                    v-if="buttonList != null && buttonList.filter(s => s.IsHide == false && s.Func.indexOf('CreateWXQRCode') != -1).length > 0"
                                    @click="CreateWXQRCode(scope.row)">生成小程序码</el-button>
                            </el-col>
                        </el-row>
                    </template>
                </el-table-column>
            </el-table>
        </el-col>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-pagination layout="total, sizes,prev, pager, next" @current-change="handleCurrentChange"
                @size-change="handleSizeChange" :current-page.sync="page" :page-size="intPageSize" :total="total"
                style="float: right"></el-pagination>
        </el-col>
    </section>
</template>

<script>
    import util from '../../../../util/date'
    import {getButtonList} from "../../../promissionRouter";
    import {getProductManagePageList,removeProductManage,getCreateWXQRCode,GetTypeListchildrenAsync,GetUserProQueryCaching} from '../../../api/api';
    export default {
        data() {
            return {
                buttonList:[],
                search: { title: "" },
                total: 0,
                page: 1,
                intPageSize:20,
                listLoading: false,
                data:[],
                
                //修改
                editFormVisible:false,  //窗口是否显示
                editLoading:false,   //loading显示
                editForm:{
                    Id: '',
                    PId:'',
                    Title:'',
                    Ioc: null,
                    FirstPng:null,
                    IocUrl: null,
                    FirstPngUrl:null
                },
                editFormRules: {
                    Title: [{ required: true, message: "请输入分类名称", trigger: "blur" }],
                },
                IocimgList:[],
                firtimgList:[],

                //所有二级分类
                TypeList:[],

                IsAdd:true, //是否
                component: "sapMatnrList",

                TypeList:[],  //fenlei数据

                 tags: []
            }
        },
        methods: {
            tableRowClassName({row, rowIndex}) {
                if (row.MatnrInfolist && row.MatnrInfolist.length > 0) {
                    // 缓存过滤结果，避免重复计算
                    const filteredList = row.MatnrInfolist.filter(s => s.MSTAE == "Z5");
                    const filteredLength = filteredList.length;
                    const totalLength = row.MatnrInfolist.length;
                    if (filteredLength === totalLength) {
                        return 'info-row';
                    } else if (filteredLength > 0 && filteredLength < totalLength) {
                        return 'warning-row';
                    }
                }
                return '';
            },
            callFunc(item) {
                 this[item.Func].apply(this, item);
            },

            getProductManagePageList() {
                 this.listLoading=true;
                let para = {
                    title: this.search.title,
                    typeId:this.search.TypeId,
                    page: this.page,
                    intPageSize:this.intPageSize,
                }
                getProductManagePageList(para).then((res) => {
                    console.log(res);
                    this.total= res.data.response.dataCount;
                    this.data = res.data.response.data?res.data.response.data:[];
                    this.listLoading=false;
                })
            },
            handleCurrentChange(val) {
                this.page = val;
                this.getProductManagePageList();
            },
            handleSizeChange(val){
               this.intPageSize = val;
               this.getProductManagePageList();
            },
            load(tree, treeNode, resolve) {
                let para = {
                    page: this.page,
                    id: tree.Id,
                };
                getPermissionTreeTable(para).then((res) => {
                    resolve(res.data.response);
                });
            },
            tagclick(name){
               this.search.title = name;
               this.query();
            },
            //查询
            query()
            {
               console.log("查询")
               this.page = 1;
               this.getProductManagePageList();
            },
            //删除
            handledel(row)
            {
                console.log(row);
                 this.$confirm("确认删除该产品信息吗？", "提示", {}).then(() => {
                    let para = {
                      id: row.Id,
                    };
                    console.log(para);
                    this.listLoading = true;
                    removeProductManage(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: res.data.msg,
                            type: "success",
                        });
                        this.getProductManagePageList();
                        } else {
                        this.$message({
                            message: "删除失败！",
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },
            //新增
            Add()
            {
               this.$router.push({
                    path: "/ManagePB/Product/AddModify"
                });
            },
            //编辑
            update(row){
                this.$router.push({
                    path: "/ManagePB/Product/AddModify",
                    query: {
                         Id: row.Id
                    },
                });
            },
            //查询
            handleView(row)
            {
                this.$router.push({
                    path: "/ManagePB/Product/AddModify",
                    query: {
                        Id: row.Id
                    },
                });
            },
            //生成二维码
            CreateWXQRCode(row)
            {
                 this.$confirm("确认生成该产品二维码信息？", "提示", {}).then(() => {
                    let para = {
                      id: row.Id,
                    };
                    console.log(para);
                    this.listLoading = true;
                    getCreateWXQRCode(para)
                    .then((res) => {
                        this.listLoading = false;
                        if (res.data.success) {
                        this.$message({
                            message: "生成成功!",
                            type: "success",
                        });
                        this.getProductManagePageList();
                        } else {
                        this.$message({
                            message: "生成失败！",
                            type: "error",
                        });
                        }
                    })
                    .catch(() => {
                        this.listLoading = false;
                    });
                });
            },
            //查询动态分类
            GetTypeListInTypeTwo()
            {
               let para={
                    typeClass : 1
                };
                GetTypeListchildrenAsync(para).then((res)=>{
                    if(res.data.success)
                    {
                        this.TypeList = res.data.response
                    }
                })
            },
            edithandleChange(val)
            {
                console.log(val);
                this.search.TypeId = val[val.length - 1];
            },
            GetUserProQueryCaching()
            {
                let para ={

                };
                GetUserProQueryCaching(para)
                .then((res)=>{
                   if(res.data.success)
                    {
                        this.tags = res.data.response
                    }

                })

            }
        },
        mounted() {
            let routers = window.localStorage.router
            ? JSON.parse(window.localStorage.router)
            : [];
            this.buttonList = getButtonList(this.$route.path, routers);
            this.getProductManagePageList();
            this.GetUserProQueryCaching()
        },
        created(){
            this.GetTypeListInTypeTwo();
        }
    }

</script>

<style>

    .el-table .warning-row {
        background: oldlace;
    }

    .el-table .info-row {
        background: #e1b3ff5d;
    }
    .role-item {
        cursor: pointer;
        padding: 10px;
    }

    .role-item.active {
        background: #ebf5ff;
    }

    .role-item:hover {
        background: #ebf5ff;
    }

    .custom-tree-node {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 14px;
        padding-right: 8px;
    }

    .text {
        font-size: 14px;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }

    .box-card {
        width: 90%;
    }


    .morechildren .el-checkbox{
        margin-right: 5px !important;
        float: left;
    }
    .morechildren .el-checkbox-group{
        margin-left: 50px;
        padding: 5px;
    }
    .morechildren .el-tree-node__content{
        height: auto !important;
    }
</style>
